import { hbs } from 'ember-cli-htmlbars';
export default hbs("<ul\n  {{breadcrumbs-container itemClass=@itemClass linkClass=@linkClass}}\n  ...attributes\n>\n  {{yield}}\n</ul>")